// Content Backlog — action types + creators

export const ADD_TO_BACKLOG_REQUEST = "ADD_TO_BACKLOG_REQUEST";
export const ADD_TO_BACKLOG_SUCCESS = "ADD_TO_BACKLOG_SUCCESS";
export const ADD_TO_BACKLOG_FAILURE = "ADD_TO_BACKLOG_FAILURE";

export const LIST_BACKLOG_REQUEST = "LIST_BACKLOG_REQUEST";
export const LIST_BACKLOG_SUCCESS = "LIST_BACKLOG_SUCCESS";
export const LIST_BACKLOG_FAILURE = "LIST_BACKLOG_FAILURE";

export const MARK_AS_POSTED_REQUEST = "MARK_AS_POSTED_REQUEST";
export const MARK_AS_POSTED_SUCCESS = "MARK_AS_POSTED_SUCCESS";
export const MARK_AS_POSTED_FAILURE = "MARK_AS_POSTED_FAILURE";

export const RESET_BACKLOG_ADD_STATE = "RESET_BACKLOG_ADD_STATE";

export const addToBacklogRequest  = (payload) => ({ type: ADD_TO_BACKLOG_REQUEST, payload });
export const addToBacklogSuccess  = (result)  => ({ type: ADD_TO_BACKLOG_SUCCESS, payload: result });
export const addToBacklogFailure  = (error)   => ({ type: ADD_TO_BACKLOG_FAILURE, error });

export const listBacklogRequest   = (payload) => ({ type: LIST_BACKLOG_REQUEST, payload });
export const listBacklogSuccess   = (items)   => ({ type: LIST_BACKLOG_SUCCESS, payload: items });
export const listBacklogFailure   = (error)   => ({ type: LIST_BACKLOG_FAILURE, error });

export const markAsPostedRequest  = (payload) => ({ type: MARK_AS_POSTED_REQUEST, payload });
export const markAsPostedSuccess  = (result)  => ({ type: MARK_AS_POSTED_SUCCESS, payload: result });
export const markAsPostedFailure  = (error)   => ({ type: MARK_AS_POSTED_FAILURE, error });

export const resetBacklogAddState = ()        => ({ type: RESET_BACKLOG_ADD_STATE });
